import React from 'react'
import styles from './Checkbox.module.scss'

interface CheckboxProps {
  id?: string
  checked?: boolean
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  disabled?: boolean
}

export function Checkbox({
  id,
  checked = false,
  onChange,
  disabled = false,
}: CheckboxProps) {
  const Wrapper: 'label' | 'div' = id ? 'div' : 'label'
  return (
    <Wrapper className={`${styles.container} ${disabled ? styles.disabled : ''}`}>
      <input
        id={id}
        type="checkbox"
        className={styles.input}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className={styles.checkmark} />
    </Wrapper>
  )
}
